<script lang="ts" setup>
const { loadLayout, layoutData } = useLayout()
await loadLayout()

const { breakpoint } = useApp()
const showAll = ref(true)
onMounted(() => {
  watchEffect(() => {
    showAll.value = !['mobile', 'phablet', 'tablet', 'desktop'].includes(breakpoint.value)
  })
})

provide('ui-heading-seo-level', 'div')
provide('ui-heading-wcag-level', '')
</script>

<template>
  <footer class="footer">
    <div class="footer__top">
      <FormNewsletter class="footer__newsletter" />
    </div>

    <div class="footer__center footer__container">
      <UiCollapsable
        class="footer__contact"
        :label="layoutData?.contact?.[0]?.Title"
        open
      >
        <FooterContact>
          <AppSocials class="footer__socials" />
        </FooterContact>

        <template #icon_after="{ open }">
          <NuxtIcon
            v-if="open"
            name="icon:min"
            class="collapsable__icon"
          />
          <NuxtIcon
            v-else
            name="icon:plus"
            class="collapsable__icon"
          />
        </template>
      </UiCollapsable>

      <UiCollapsable
        v-if="layoutData?.footerMenu1?.[0]?.Items?.length"
        :key="showAll"
        class="footer__menu footer__menu--1"
        :label="layoutData?.footerMenu1?.[0]?.Title"
        :open="showAll"
      >
        <FooterMenu
          v-if="layoutData?.footerMenu1?.[0]"
          :menu="layoutData.footerMenu1[0]"
        />

        <template #icon_after="{ open }">
          <NuxtIcon
            v-if="open"
            name="icon:min"
            class="collapsable__icon"
          />
          <NuxtIcon
            v-else
            name="icon:plus"
            class="collapsable__icon"
          />
        </template>
      </UiCollapsable>

      <UiCollapsable
        v-if="layoutData?.footerMenu2?.[0]?.Items?.length"
        :key="showAll"
        class="footer__menu footer__menu--2"
        :label="layoutData?.footerMenu2?.[0]?.Title"
        :open="showAll"
      >
        <FooterMenu
          v-if="layoutData?.footerMenu2?.[0]"
          :menu="layoutData.footerMenu2[0]"
        />

        <template #icon_after="{ open }">
          <NuxtIcon
            v-if="open"
            name="icon:min"
            class="collapsable__icon"
          />
          <NuxtIcon
            v-else
            name="icon:plus"
            class="collapsable__icon"
          />
        </template>
      </UiCollapsable>

      <UiCollapsable
        v-if="layoutData?.footerMenu3?.[0]?.Items?.length"
        :key="showAll"
        class="footer__menu footer__menu--3"
        :label="layoutData?.footerMenu3?.[0]?.Title"
        :open="showAll"
      >
        <FooterMenu
          v-if="layoutData?.footerMenu3?.[0]"
          :menu="layoutData.footerMenu3[0]"
        />

        <template #icon_after="{ open }">
          <NuxtIcon
            v-if="open"
            name="icon:min"
            class="collapsable__icon"
          />
          <NuxtIcon
            v-else
            name="icon:plus"
            class="collapsable__icon"
          />
        </template>
      </UiCollapsable>

      <ReviewComponent
        class="footer__rating"
        :source="'feedbackcompany'"
      />
    </div>

    <div class="footer__bottom footer__container">
      <div class="footer__icons">
        <AppPaymentIcons class="footer__payment-icons" />
        <!-- <AppDeliveryIcons class="footer__delivery-icons" /> -->
        <AppTrustmarkIcons class="footer__trustmark-icons" />
      </div>

      <FooterLegal class="footer__legal" />

      <FooterCopyright class="footer__copyright" />
    </div>
  </footer>
</template>

<style>
@import url("~layers/components/Footer/Component.css");
</style>
